import {css} from "@emotion/react";

export const editDeleteContainer = css`
    display: grid;
    padding-top: 5px;
    justify-content: flex-end;
    width: 100%;
    grid-template-columns: auto auto;
`;

export const errorSpan = css`
    margin-top: 4px;
    padding-right: 10px;
    font-size: 13px;
    color: #ff0000;
`;

export const bigError = css`
    text-align: right;
    width: 100%;
    margin-top: 14px;
    padding-right: 10px;
    font-size: 16px;
    color: red;
`;

// The caret that expands the RAM graphs. A real button so it is keyboard
// reachable, stripped back so it reads as part of the row label.
export const graphToggle = css`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0;
    border: none;
    background: none;
    font: inherit;
    color: inherit;
    cursor: pointer;
    text-align: left;

    &:focus-visible {
        outline: 2px solid #4A90D9;
        outline-offset: 2px;
    }
`;

export const graphCaret = css`
    display: inline-block;
    width: 10px;
    font-size: 11px;
    line-height: 1;
`;

// Graphs stack full width below the row and push everything after them down.
export const graphPanel = css`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    margin-top: 12px;
`;

export const graphFigure = css`
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
    margin: 0;
`;

export const graphImage = css`
    display: block;
    width: 100%;
    max-width: 100%;
    height: auto;
`;

export const graphMissing = css`
    font-size: 13px;
    font-style: italic;
    color: #9B9B9B;
`;

